import { render, staticRenderFns } from "./CloseBtn.vue?vue&type=template&id=66590cee&scoped=true&"
import script from "./CloseBtn.vue?vue&type=script&lang=js&"
export * from "./CloseBtn.vue?vue&type=script&lang=js&"
import style0 from "./CloseBtn.vue?vue&type=style&index=0&id=66590cee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66590cee",
  null
  
)

export default component.exports